import React from "react";

function ValidationError({ meta, name }) {
	if (!meta) return null;

	return <div className="input-field-validation" data-id={name}>{meta.error && meta.touched && <span>{meta.error}</span>}</div>;
}

export default ValidationError;
